module.exports = __webpack_public_path__ + "img/CommentIcon.1d21087b.svg";